import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import { Alert as MuiAlert } from '@mui/material';
import { makeStyles } from 'utils/makeStylesAdapter';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

const SnackbarAlert = props => {
  const { severity = 'info', open, onClose, message, time = 3000 } = props;

  const classes = useStyles();

  /*
      Colors for used
      severity="error"
      severity="warning"
      severity="info"
      severity="success"
    */

  return (
    <div className={classes.root}>
      <Snackbar
        open={open}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        autoHideDuration={time}
        onClose={onClose}
      >
        <Alert onClose={onClose} severity={severity}>
          {message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default SnackbarAlert;
